/* eslint-disable class-methods-use-this */
/* eslint-disable max-classes-per-file */
import Observer from '../classes/Observer';

class VideosWithSound extends Observer {
  constructor() {
    super({
      isOnce: false,
    });

    this.$soundBtns = $('.sound-button');
    this.$videos = this.$soundBtns.siblings('video');
    this.isHeroMuted = true;
    this.$heroVideo = $('.hero video');

    this.init();
  }

  init() {
    if (!this.$videos.length) return;

    this.$videos.each((i, target) => {
      this.observer.observe(target);
    });

    this.$soundBtns.on('click', this.toggleSound.bind(this));
  }

  toggleSound(e) {
    const $cur = $(e.currentTarget);
    const $video = $cur.siblings('video');

    if ($video[0].muted) {
      this.unmuteVideo($video);
    } else {
      this.muteVideo($video);
    }
  }

  muteVideo(target) {
    const $video = $(target);
    const $parent = $video.parent();

    $video[0].muted = true;
    $parent.addClass('is-muted');

    if ($parent.closest('.hero').length) {
      this.isHeroMuted = true;
    }
  }

  unmuteVideo(target) {
    // mute all other videos
    this.$videos.each((i, video) => {
      if (video.muted) return;
      this.muteVideo(video);
    });

    // unmute the current video
    const $video = $(target);
    const $parent = $video.parent();

    $video[0].muted = false;
    $parent.removeClass('is-muted');

    if ($parent.closest('.hero').length) {
      this.isHeroMuted = false;
    }
  }

  animateOut(target) {
    super.animateIn();
    this.muteVideo(target);
  }

  onScroll() {
    const st = $(window).scrollTop();
    const wh = $(window).height();

    if (st > wh && !this.isHeroMuted) {
      this.muteVideo(this.$heroVideo);
    }
  }
}

export default VideosWithSound;
